import React, { Component, createRef } from 'react';
import {
  Button,
  FormGroup,
  Col, 
  Container,
  Input,
  Row
} from 'reactstrap';
import ApiCall from '../../../services/ApiCall'
import Helper, { showSwalLoading } from '../../../services/Helper'
import swal from 'sweetalert2'
import jwt from 'jsonwebtoken'
// import {Redirect} from 'react-router-dom'
import './Login.css'
import ReCAPTCHA from 'react-google-recaptcha'

class Login extends Component {

  constructor() {
    super()
    this.reRef = createRef()
  }

  state = {
    username: '',
    password: '',
    loading: true
  }

  style = {
    backgroundImage: 'linear-gradient(#9675ce,#9675ce),linear-gradient(rgba(120,130,140,.13),rgba(120,130,140,.13))',
    border: 0,
    borderRadius: 0,
    boxShadow: 'none',
    backgroundColor: 'transparent',
    backgroundPosition: 'center bottom,center calc(99%)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '0 2px,100% 1px',
    padding: 0
  }

  componentWillMount() {
    let token = localStorage.getItem('token')
    if (token != null) {
      let userData = jwt.decode(token)
      if (userData) {
        let user = userData.user
        if (user) {
          window.location = '/#/home'
        }
      }
    }
  }

  componentDidMount() {
    this.setState({loading:false})
  }

  toAgc(){
    window.location.href=`${process.env.SWITCH_TO_AGC || 'https://agction.astra.co.id'}`
  }

  async login (e) {
    e.preventDefault()
    let { username, password } = this.state

    const tokenCaptcha = await this.reRef.current.executeAsync();
    this.reRef.current.reset()

    showSwalLoading()
    try {
      const res = await ApiCall.login({ username, password, tokenCaptcha })
      swal.close()
      this.props.history.push('/login/verify-otp')
      let email = res.data.email
      localStorage.setItem('email', email)
    } catch (error) {
      swal.close()
      if (error.response) {
        swal('Oops...', error.response.data.message, 'error').then((result) => {
          let { username } = this.state 
          window.location.reload().then((result) => {
            this.setState({username})
          })
        })
      } else {
          swal('Oops...', 'Something went wrong! Check internet connection!', 'error').then((result) => {
            window.location.reload()
          })
          console.error('error message: ', error)
      }
    }
  }


  render() {
    let {username, password, loading} = this.state
    // if (loading) return (<div></div>)
    return (
      <div className="app flex-row align-items-center background-home">
        <Container>
          <div className="card-form-login"> 
            
              <div className='text-center logo'>
                FRIENDLY
                  <img src={'/assets/img/brand/AFC.jpg'} className="" alt="logo astra green company" />                             
                C O M P A N Y
              </div>

              <p className="text-uppercase text-semibold m-b-15">Sign In</p>

              <form onSubmit={this.login.bind(this)}>
                <Row>
                  <Col xs="12">
                   <ReCAPTCHA 
                      ref={this.reRef}
                      sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                      size="invisible"
                    />
                    <FormGroup>
                      <Input 
                        style={this.style} 
                        value={username} 
                        bsSize="lg" 
                        type="text" 
                        id="name" 
                        placeholder="Email"
                        onChange={e => { this.setState({username:e.target.value}) }}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col xs="12">
                    <FormGroup>
                      <Input 
                        style={this.style} 
                        value={password} 
                        bsSize="lg" 
                        type="password" 
                        id="ccnumber" 
                        placeholder="Password"
                        onChange={e => { this.setState({password:e.target.value}) }}
                      />
                    </FormGroup>
                  </Col>
              </Row>
              <Row>
                <Col
                  xs="12"
                  className="text-right mb-2"
                >
                    <a
                      href="/#/forgot-password"
                    style={{
                        textDecoration: 'none'
                      }}
                    >Forgot Password ?</a>
                  </Col>
              </Row>
              
                <Row>
                  <Col xs="12">
                    <Button className="btn btn-success btn-lg btn-loading btn-block text-uppercase waves-effect waves-light" type="submit">Log in</Button>
                  </Col>
                  <Col xs="12" style={{paddingTop: 20}}>
                    <Button className="btn btn-success btn-lg btn-loading btn-block text-uppercase waves-effect waves-light" onClick={this.toAgc}>SWITCH TO AGC</Button>
                  </Col>
                </Row>
              </form>

          </div>
        </Container>
      </div>
    );
  }
}

export default Login;
